import radioButton from './radio-button.vue'

radioButton.install = function(Vue) {
  Vue.component(radioButton.name, radioButton)
}

export default radioButton
